export default "__VITE_ASSET__1b9bcdbe__"